import { shallowEqual, useSelector } from 'react-redux';


class Acl {

  static getUserPermissions() {
    const mapStateToProps = (state) => {
      const auth = state.auth;
      if (auth){
        return auth.user ? auth.user.permissions : [];
      } else {
        return [];
      }
    }

    return useSelector(mapStateToProps,shallowEqual);
  }

  static hasPermission(permission) {   
    return this.getUserPermissions().includes(permission);
  }

  static can(permission = "", Component = null, customPermissions = null /*array*/) {

    if (!permission) return false;    
    const allowed = !customPermissions ? this.hasPermission(permission) : customPermissions.includes(permission);
    
    
    if (Component) {
      return allowed && Component;
    }
    
    return allowed;
    
  }
}

export default Acl;
